/** The tokens toolbar: search, status and scope filters, Refresh, How to connect, and Create token last. */

import { Plug, Plus, Search } from 'lucide-react';

import { queryKeys } from '@/api/queries';
import { MultiSelect } from '@/ui/MultiSelect';
import { RefreshButton } from '@/ui/RefreshButton';

import { SCOPES } from './mcpScopes';

export type TokenStatus = 'active' | 'expired';

export interface TokenFilters {
  q: string;
  /** Nothing ticked means every status or scope. */
  status: TokenStatus[];
  scope: string[];
}

const STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'expired', label: 'Expired' },
];

export function TokensToolbar({
  filters,
  onChange,
  onConnect,
  onCreate,
}: {
  filters: TokenFilters;
  onChange: (patch: Partial<TokenFilters>) => void;
  onConnect: () => void;
  onCreate: () => void;
}) {
  return (
    <div className="toolbar filter-panel">
      <div className="search-field">
        <Search aria-hidden="true" />
        <input
          type="search"
          value={filters.q}
          placeholder="Search tokens"
          aria-label="Search token names"
          onChange={(e) => onChange({ q: e.target.value })}
        />
      </div>
      <MultiSelect
        label="Filter by status"
        allLabel="All statuses"
        noun="statuses"
        options={STATUSES}
        value={filters.status}
        onChange={(status) => onChange({ status: status as TokenStatus[] })}
      />
      <MultiSelect
        label="Filter by scope"
        allLabel="All scopes"
        noun="scopes"
        options={SCOPES.map(({ key, label }) => ({ value: key, label }))}
        value={filters.scope}
        onChange={(scope) => onChange({ scope })}
      />
      <RefreshButton iconOnly queryKeys={[queryKeys.mcpTokens]} />
      <button type="button" className="btn btn-secondary" onClick={onConnect}>
        <Plug aria-hidden="true" /> How to connect
      </button>
      <button type="button" className="btn btn-primary toolbar-primary" onClick={onCreate}>
        <Plus aria-hidden="true" /> Create token
      </button>
    </div>
  );
}
